import React, {useEffect} from 'react';
import { InputAdornment, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector} from 'react-redux';
import CustomTimePicker from '../../../../../../components/CustomTimePicker';
import { CustomTextField } from '../../../../../../components/CustomTextField';
import { CustomSelect } from '../../../../../../components/CustomSelect';
import {timeToSeconds} from '../../../../../../Apis/functions';

const ShiftTimePicker = ({
    startShiftAt,
    setStartShiftAt,
    endShiftAt,
    setEndShiftAt,
    range,
    setRange,
    selectedDepartment,
    setSelectedDepartment,
    readOnly,
    displayNone,
    showErrors,
}) => {
    const { t } = useTranslation();

    const {getAllDepartments: allDepartments } = useSelector((state) => state.DocumentPanelSlice);

    useEffect(() => {
        if(setEndShiftAt){
            if (!startShiftAt || !endShiftAt) return;
            const startSeconds = timeToSeconds(startShiftAt);
            const endSeconds = timeToSeconds(endShiftAt);
            if (startSeconds > endSeconds) {
                setEndShiftAt('');
            }
        }
    }, [startShiftAt, endShiftAt]);

    return (
        <>
            <div className='col-12 col-md-6 mb-4'>
                <CustomTimePicker
                    id='dtp_stp_start_shift_at'
                    title={t('start_shift_at')}
                    name={'startShiftAt'}
                    value={startShiftAt}
                    handleChange={(e) => {
                        if(setStartShiftAt) setStartShiftAt(e);
                    }}
                    ampm={false}
                    disabled={readOnly}
                    required={true}
                    emptyFields={showErrors && !startShiftAt}
                    formatInvalid={false}
                    formatValue={true}
                />
            </div>
            <div className='col-12 col-md-6 mb-4'>
                <CustomTimePicker
                    id='dtp_stp_end_shift_at'
                    title={t('end_shift_at')}
                    name={'endShiftAt'}
                    value={endShiftAt}
                    handleChange={(e) => {
                        if(setEndShiftAt) setEndShiftAt(e);
                    }}
                    ampm={false}
                    disabled={readOnly}
                    required={true}
                    emptyFields={showErrors && !endShiftAt}
                    formatInvalid={false}
                    minTime={startShiftAt}
                />
            </div>
            <div className='col-12 col-md-6 mb-4'>
                <CustomTextField
                    id='txt_stp_range'
                    label={`${t('range')?.toUpperCase()} *`}
                    value={range}
                    trans='range'
                    disabled={readOnly}
                    onChange={(e) => setRange(e.target.value)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <span>{t('min')?.toUpperCase()}</span>
                            </InputAdornment>
                        ),
                    }}
                    type='number'
                    length={10}
                    noUppercase={false}
                />
            </div>
            {!displayNone && (
                <div className='col-12 col-md-6 mb-4'>
                    <CustomSelect
                        id='slt_stp_departments'
                        value={selectedDepartment}
                        readOnly={readOnly}
                        disabled={readOnly}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                        trans='department'
                        list={allDepartments}
                        keyName='id'
                        required={true}
                        emptyFields={!selectedDepartment && showErrors}
                        showNoSelectionOption={false}
                    />
                </div>
            )}
        </>
    );
};

export default ShiftTimePicker;
